
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-custom-plugin-demo-custom","docs-x-markdown-custom-plugin-demo-marked"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.zh-CN.md?type=demo')
};